/**
 * @generated SignedSource<<783cb44022bbaf3f1b46a0fd9e84e34e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateUserLanguageInput = {
  clientMutationId?: string | null;
  language: string;
};
export type LanguagePopoverUpdateUserLanguageMutation$variables = {
  input: UpdateUserLanguageInput;
};
export type LanguagePopoverUpdateUserLanguageMutation$data = {
  readonly updateUserLanguage: {
    readonly user: {
      readonly id: string;
      readonly language: string;
    } | null;
  } | null;
};
export type LanguagePopoverUpdateUserLanguageMutation = {
  response: LanguagePopoverUpdateUserLanguageMutation$data;
  variables: LanguagePopoverUpdateUserLanguageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUserLanguagePayload",
    "kind": "LinkedField",
    "name": "updateUserLanguage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LanguagePopoverUpdateUserLanguageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LanguagePopoverUpdateUserLanguageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d35aa36218d0883dcc5d1957d2cc0c20",
    "id": null,
    "metadata": {},
    "name": "LanguagePopoverUpdateUserLanguageMutation",
    "operationKind": "mutation",
    "text": "mutation LanguagePopoverUpdateUserLanguageMutation(\n  $input: UpdateUserLanguageInput!\n) {\n  updateUserLanguage(input: $input) {\n    user {\n      language\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "61401bff2da3bf3c08e89d65a97340de";

export default node;
